module.exports = __webpack_public_path__ + "public/Icons/clockDark.svg?ed4ade30";